import { useState, useCallback } from 'react';

export type RefreshToken = number;
export type RefreshFunc = () => void;

export default function useRefresh(): [RefreshToken, RefreshFunc] {
  const [refreshToken, setRefreshToken] = useState<RefreshToken>(0);

  const refresh = useCallback(() => {
    setRefreshToken(refreshToken + 1);
  }, [refreshToken]);

  return [refreshToken, refresh];
}
